import { cardIcons } from '../../constants';
import defaultIcon from '../../../../icons/default.svg';
import cvvBack from '../../../../icons/cvv-back.svg';
import cvvFront from '../../../../icons/cvv-front.svg';

const path = `https://${FRAME_LIBRARY_URL}/vgs-collect/icons`;

export function getCardIconSrc(
  cardType: string | undefined,
  customIcons: Record<string, string> | undefined | null
): string | undefined {
  const cardPlaceholder = customIcons?.cardPlaceholder || defaultIcon;
  if (!cardType) {
    return cardPlaceholder;
  }
  const builtInIcon = cardIcons[cardType] ? `${path}/${cardIcons[cardType]}.svg` : undefined;
  const clientIcon = customIcons?.[cardType];
  return clientIcon || builtInIcon || cardPlaceholder;
}

export function getCvvIconSrc(
  cardType: string | undefined,
  customIcons: Record<string, string> | undefined | null
): string | undefined {
  const isFront = cardType === 'amex';
  if (isFront) {
    return customIcons?.cvvFront || cvvFront;
  } else {
    return customIcons?.cvvBack || cvvBack;
  }
}
